import React, { PropsWithChildren, useState } from 'react';

import ErrorInspector from '@/components/shared/ErrorInspector';
import {
	useAnalyzeBiblePassageMutation,
	useAnalyzeLyricsMutation,
	useTestEnrichMutation,
} from '@/graphql';
import { FetchError } from '@/graphql/codegen-fetcher';
import {
	Button,
	ButtonGroup,
	FormControl,
	FormLabel,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
	Stack,
	Text,
	Textarea,
} from '@chakra-ui/react';
import { Formik } from 'formik';
import * as yup from 'yup';

const enrichTagInputSchema = yup.object({
	text: yup.string().defined(),
});

const initialValues: {
	text: string;
} = {
	text: '',
};

export type CreateRecordInitialValues = typeof initialValues;

type AnalyzePassageModalProps = {
	isOpen: boolean;
	onClose: () => void;
};

const AnalyzePassageModal: React.FC<AnalyzePassageModalProps> = ({
	isOpen,
	onClose,
}) => {
	const { mutateAsync, data } = useAnalyzeBiblePassageMutation<FetchError>();
	const [result, setResult] = useState<string>('');

	return (
		<Modal isOpen={isOpen} onClose={onClose}>
			<ModalOverlay />
			<ModalContent>
				<ModalHeader>Analyze Bible Passage</ModalHeader>
				<ModalCloseButton />
				<Formik
					initialValues={initialValues}
					validationSchema={enrichTagInputSchema}
					onSubmit={async (values, formikHelpers) => {
						try {
							const res = await mutateAsync({
								text: values.text,
							});
							setResult(
								JSON.stringify(
									JSON.parse(res.analyzeBiblePassage || '{}'),
									null,
									4,
								),
							);
						} catch (err) {
							console.error(err);
						} finally {
							formikHelpers.setSubmitting(false);
						}
					}}
				>
					{({
						submitForm,
						handleSubmit,
						handleChange,
						values,
						errors,
						setFieldValue,
					}) => {
						return (
							<form onSubmit={handleSubmit}>
								<ModalBody>
									<FormControl>
										<Stack spacing={4}>
											<FormControl isRequired>
												<FormLabel>Text</FormLabel>
												<Textarea
													placeholder="text"
													name="text"
													onChange={handleChange}
													value={values.text}
												/>
											</FormControl>
										</Stack>
									</FormControl>

									<ErrorInspector
										JSON={{
											form: errors,
											request: data,
										}}
									/>

									<pre>{result}</pre>
								</ModalBody>
								<ModalFooter>
									<ButtonGroup w="100%" spacing={2}>
										<Button
											onClick={submitForm}
											type="submit"
										>
											Test
										</Button>
									</ButtonGroup>
								</ModalFooter>
							</form>
						);
					}}
				</Formik>
			</ModalContent>
		</Modal>
	);
};

export default AnalyzePassageModal;
